<form [formGroup]="form">
  <div class="mb-4">
    <label class="label">
      <nk-entity-match-decision-type-title
        [isCompany]="!!screeningCaseComposite().company"
        [severalMatches]="severalMatches()"></nk-entity-match-decision-type-title>
      *
    </label>
    @if (entityMatchDecisionTypeList$ | async; as entityMatchDecisionTypeList) {
      @for (item of entityMatchDecisionTypeList; track item.uuid) {
        <span class="form-check mb-0">
          <input
            class="form-check-input ng-untouched ng-pristine ng-valid"
            type="radio"
            formControlName="entity_match_decision_type_uuid"
            (change)="updatePepConfirmedFlag(entityMatchDecisionTypeList)"
            [id]="item.entity_match_decision_type_key + '_' + uniqueId()"
            [value]="item.uuid" />
          <label [for]="item.entity_match_decision_type_key + '_' + uniqueId()" class="form-check-label">
            {{ entityMatchDecisionTypeTranslations[item.entity_match_decision_type_key] | translate }}
          </label>
        </span>
      }
    }
  </div>

  @if (screeningCaseComposite().screening_case.pep_flag && showPepConfirmedFlag()) {
    <div class="mb-4">
      <label class="label">{{ 'screening.case.forms.pep_confirmed_flag.title' | translate }} *</label>
      <span class="form-check mb-0">
        <input
          class="form-check-input ng-untouched ng-pristine ng-valid"
          type="radio"
          formControlName="pep_confirmed_flag"
          [id]="'pep_confirmed_flag_true_' + uniqueId()"
          [value]="true" />
        <label [for]="'pep_confirmed_flag_true_' + uniqueId()" class="form-check-label">
          {{ 'screening.case.forms.pep_confirmed_flag.yes' | translate }}
        </label>
      </span>
      <span class="form-check mb-0">
        <input
          class="form-check-input ng-untouched ng-pristine ng-valid"
          type="radio"
          formControlName="pep_confirmed_flag"
          [id]="'pep_confirmed_flag_false_' + uniqueId()"
          [value]="false" />
        <label [for]="'pep_confirmed_flag_false_' + uniqueId()" class="form-check-label">
          {{ 'screening.case.forms.pep_confirmed_flag.no' | translate }}
        </label>
      </span>
    </div>
  }

  <div class="mb-4">
    <label class="label" [for]="'screening_case_review_comment_' + uniqueId()">
      {{ 'screening.case.forms.comment.title' | translate }}
      @if (isControlRequired('screening_case_review_comment')) {
        <span> *</span>
      }
    </label>
    <textarea
      class="form-control w-100"
      [id]="'screening_case_review_comment_' + uniqueId()"
      formControlName="screening_case_review_comment"></textarea>
  </div>

  <div [hidden]="true">
    <h6>{{ 'screening.case.forms.files.title' | translate }}</h6>
    <button nkButton color="secondary">
      {{ 'screening.case.forms.files.attach_file' | translate }}</button
    ><br />
  </div>
</form>

@if (showActions()) {
  <div class="row">
    @if (!isReviewComplete()) {
      <div class="col-6 col-lg-12 mb-0 mb-lg-2">
        <button
          nkButton
          color="primary"
          class="w-100"
          [disabled]="form.invalid || isLoading()"
          (click)="saveReview(false)">
          <i class="fa fa-floppy-o"></i>
          {{ 'screening.case.review.save_progress' | translate }}
        </button>
      </div>
      <div class="col-6 col-lg-12">
        <button
          nkButton
          color="success"
          class="w-100"
          [disabled]="form.invalid || isLoading()"
          (click)="saveReview(true)">
          <i class="fa fa-check me-1"></i>
          {{ 'screening.case.review.complete_review' | translate }}
        </button>
      </div>
    } @else {
      <div class="col">
        @if (reviewerEmail()) {
          @let reviewComposite = screeningCaseReviewCompositeEntity();
          <div class="alert alert-success">
            <i class="fa fa-check me-1"></i>
            <span
              [innerHTML]="
                'screening.case.review.review_done'
                  | translate
                    : {
                        reviewer: reviewerEmail(),
                        completeDate:
                          (reviewComposite?.screening_case_review?.complete_timestamp | date: dateFormats.DateAndTime),
                      }
              "></span>
          </div>
          <button
            nkButton
            color="primary"
            [ghost]="true"
            class="mt-4"
            [disabled]="isLoading()"
            (click)="createReview()">
            <i class="fa fa-refresh me-1"></i>
            {{ 'screening.case.review.start_again_button' | translate }}
          </button>
        }
      </div>
    }
  </div>
}
